import { TracksState } from './state';

export const trackInitialState: TracksState = {
  tracks: {},
  invalidForm: false,
  updateStatus: 'initial',
  disableReplicateCollaborators: false,
};
